(function () {
  const drawer = document.getElementById('menu-drawer');
  if (!drawer) return;

  const colChildren = drawer.querySelector('.menu-drawer__col--children');
  const productCols = Array.from(drawer.querySelectorAll('.menu-drawer__col--product'));
  const BREAKPOINT = 750;

  // Snapshot default product HTML once on load so we can restore it
  const defaultProductHTML = productCols.map((col) => col.innerHTML);

  function isDesktop() {
    return window.innerWidth >= BREAKPOINT;
  }

  function restoreDefaultProducts() {
    productCols.forEach((col, i) => {
      col.innerHTML = defaultProductHTML[i];
    });
  }

  function updateProductCols(detailsEl) {
    const collProducts = detailsEl.querySelector('.menu-drawer__coll-products');

    if (!collProducts) {
      restoreDefaultProducts();
      return;
    }

    const cards = Array.from(collProducts.querySelectorAll('.menu-drawer__coll-product-card'));

    productCols.forEach((col, i) => {
      if (cards[i]) {
        // Clone so the hidden original remains intact for future selections
        const clone = cards[i].cloneNode(true);
        clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
        col.innerHTML = '';
        col.appendChild(clone);
      } else {
        col.innerHTML = '';
      }
    });
  }

  function clearSelection() {
    drawer.querySelectorAll('[data-desktop-selected]').forEach((el) => {
      el.removeAttribute('data-desktop-selected');
    });
    if (colChildren) colChildren.innerHTML = '';
    restoreDefaultProducts();
  }

  function selectParent(detailsEl) {
    const wasSelected = detailsEl.hasAttribute('data-desktop-selected');
    clearSelection();

    if (!wasSelected) {
      detailsEl.setAttribute('data-desktop-selected', '');

      // Populate children column (column 2)
      const childList = detailsEl.querySelector('.menu-drawer__children');
      if (childList && colChildren) {
        const clone = childList.cloneNode(true);
        clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
        clone.removeAttribute('id');
        colChildren.appendChild(clone);
      }

      // Swap product columns 3–5 with collection-specific products (or keep defaults)
      updateProductCols(detailsEl);
    }
  }

  drawer.addEventListener('click', function (e) {
    if (!isDesktop()) return;

    const summary = e.target.closest('.menu-drawer__menu-item--has-children');
    if (!summary) return;

    e.preventDefault();
    selectParent(summary.closest('details'));
  });

  // Clear desktop state when resizing back to mobile
  window.addEventListener('resize', function () {
    if (!isDesktop()) clearSelection();
  });
})();
